module.exports = __webpack_public_path__ + "img/zz1.e92f83c3.jpg";